import {IRequest} from 'src/domains';

export const checkReviewExpected = (call: IRequest, userId: string) => {
  let isReviewExpected = false;
  if (call.status === 'CALL_FINISHED') {
    if (
      (new Date(call.finishedAt || '').getTime() -
        new Date(call.startedAt || '').getTime()) /
        1000 -
        (call.freeTime || 0) >
      0
    ) {
      isReviewExpected =
        call.senderId === userId ? !call.senderReview : !call.opponentReview;
    }
  }

  return isReviewExpected;
};
